<script>
import { ref } from 'vue';
import IconSvg from '../message-center-list/src/components/IconSvg';
const isHttps = window.location.protocol === 'https:';
const getStrCharCodeLen = (str) => {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 127 || +str.charCodeAt(i) === 94) {
      len += 2;
    } else {
      len++;
    }
  }
  return len;
};
const getImageUrl = (image) => image?.[isHttps ? 'urlHttps' : 'url'];
import Props from './props';
export default {
  components: { IconSvg },
  props: Props,
  emits: ['cardClick'],
  setup() {
    const isSeeAll = ref(false);
    return {
      rightIcon: require('../message-center-list/src/static/right.svg'),
      ellipsis: true,
      isSeeAll: isSeeAll,
      putSeeAll() {
        isSeeAll.value = !isSeeAll.value;
      },
      getLastModuleName(module = '') {
        const getLast = (list) => {
          if (list.length === 0) return null;
          return list.pop() || getLast(temps);
        };
        const temps = module.split('>') || [];
        return getLast(temps);
      },
    };
  },
  methods: {
    goLink() {
      if (!this.link) return;
      window.open(this.link);
    },
  },
  render(_) {
    function getUrl(image) {
      return image?.[isHttps ? 'urlHttps' : 'url'];
    }
    const ImageLoading = (
      <pb-skeleton slot="placeholder" style="width:100%; height:100%" loading={true} animated>
        <template slot="template" style="width: 100%; height: 100%;">
          <pb-skeleton-item variant="image" style="width: 100%; height: 100%;" />
        </template>
      </pb-skeleton>
    );

    return (
      <div
        class={{ 'message-card': true, 'is-card': this.isCard }}
        onClick={(evt) => {
          this.$emit('cardClick', evt);
        }}
      >
        {getUrl(this.images[0]) ? (
          <pb-image lazy data-type="封面图片" fit="cover" class="message-card-image" src={getUrl(this.images[0])}>
            {ImageLoading}
          </pb-image>
        ) : null}
        <div class="message-card-content">
          <div>
            <div class="message-card-date">
              <span>{this.datetime}</span>
              {this.getLastModuleName(this.module) ? <i>|</i> : null}
              <span>{this.getLastModuleName(this.module)}</span>
            </div>
            <p class={'message-card-title' + (this.unRead ? ' message-card-title-un-read' : '')}>{this.title}</p>
          </div>
          <div class={'message-card-description' + (!this.isSeeAll && getStrCharCodeLen(this.content) > 132 ? ' message-card-description-ellipsis' : '')}>
            <p domPropsInnerHTML={this.content + '<i>&emsp;&emsp;&emsp;</i>'} />
            {getStrCharCodeLen(this.content) > 133 ? (
              <span class="message-card-description-point" onClick={this.putSeeAll}>
                {!this.isSeeAll ? this.$t('Gattaran_MSGCenter__VINe' /** 展开 */) : this.$t('Gattaran_MSGCenter__WOKq' /** 收起 */)}
              </span>
            ) : null}
          </div>
          {Array.isArray(this.images) && this.images.length > 0 ? (
            <div class="message-card-image-contents">
              {this.contentImages.map((image) => {
                const url = getImageUrl(image);
                return url ? (
                  <pb-image lazy data-type="卡片内容图片" fit="cover" class="message-card-image-content" src={url} previewSrcList={this.contentImages.map((i) => getImageUrl(i))}>
                    {ImageLoading}
                  </pb-image>
                ) : // <div class="message-card-image-content">
                //   <img src={url} alt="" />
                // </div>
                null;
              })}
            </div>
          ) : null}
        </div>
        {this.link ? (
          <section class="message-card-footer">
            <pb-button
              data-type="查看详情按钮"
              onClick={() => {
                setTimeout(() => {
                  this.goLink();
                }, 50);
              }}
              type="primary"
            >
              {this.linkText || this.$t('Gattaran_V2_NzFp_yjYY' /*查看详情*/)}
            </pb-button>
          </section>
        ) : null}
        {this.isCard ? (
          <span data-type="卡片关闭按钮" class="message-card-close">
            <i
              class="GQ-close"
              onClick={() => {
                setTimeout(() => {
                  this.close();
                }, 50);
              }}
            ></i>
          </span>
        ) : null}
      </div>
    );
  },
};
</script>
<style lang="scss" scoped>
@import '../message-center-list/src/common.ignore';

$prefix: 'message-card';
@mixin notifications($fix) {
  $p: $prefix + '-' + $fix;
  .#{$p} {
    @content;
  }
}

.message-card {
  position: relative;
  background: #fff;
  border-radius: 8px;
  width: 392px;
  //border: 1px solid #e9eaee;
  box-sizing: border-box;
  overflow: hidden;
  &.is-card {
    position: fixed;
    z-index: 2000;
    top: 60px;
    right: 20px;
    width: 392px;
    max-height: 480px;
    background: #ffffff;
    border: 1px solid #e9eaee;
    box-shadow: 0 3px 8px 0 rgba(3, 4, 5, 0.08);
    border-radius: 8px;
    box-sizing: border-box;
    .message-card-content {
      overflow: scroll;
      max-height: calc(480px - 131px - 56px - 16px - 10px);
    }
  }
  &:hover {
    box-shadow: 0 3px 8px 0 rgba(3, 4, 5, 0.08);
    @include notifications(icon) {
      transition: all 0.35s ease-in-out;
      transform: translateX(4px);
      path {
        transition: all 0.35s ease-in-out;
        fill: #3e4047 !important;
      }
    }
    @include notifications(description-point) {
      background-image: linear-gradient(270deg, #fff 69%, rgba(250, 248, 248, 0) 100%);
    }
  }
  .message-card-image {
    box-sizing: border-box;
    width: 392px;
    height: 131px;
    overflow: hidden;
    background: #f0f1f5;
    img {
      width: 100%;
    }
  }
  .message-card-image-contents {
    display: grid;
    grid-template-columns: repeat(4, 25%);
    padding-top: 12px;
    .message-card-image-content {
      box-sizing: border-box;
      width: 84px;
      height: 84px;
      overflow: hidden;
      background: #f0f1f5;
      img {
        width: 100%;
      }
    }
  }
  .message-card-content {
    padding: 12px 14px;
    box-sizing: border-box;
  }
  .message-card-footer {
    padding: 0 16px 16px;
  }
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    cursor: pointer;
  }
  .image-slot {
    background: #f0f1f5;
    width: 100%;
    height: 100%;
  }
}
@include notifications(icon) {
  display: inline-block;
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 0;
  width: 14px;
  height: 14px;
  path {
    fill: #c2c4cc !important;
  }
}
@include notifications(date) {
  @include fontFamily();
  //font-family: DiDiSans-Pro-Thin;
  position: relative;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #8d9099;
  font-weight: normal;
  i {
    color: #e9eaee;
    font-style: normal;
    margin: 0 8px;
  }
  img {
    cursor: pointer;
    position: absolute;
    top: 2px;
    right: 0;
    color: #c2c4cc;
    width: 14px;
  }
}
@include notifications(title) {
  //font-family: DiDiSans-Pro-Bold;
  @include fontFamily();
  position: relative;
  margin: 0 0 4px 0;
  //height: 22px;
  line-height: 22px;
  font-size: 14px;
  color: #282b33;
  font-weight: bold;
  word-wrap: break-word;
  display: inline-block;
}
@include notifications(title-un-read) {
  font-weight: bold;
}
@include notifications(description) {
  @include fontFamily();
  //font-family: DiDiSans-Pro-Regular;
  position: relative;
  display: inline-block;
  font-size: 12px;
  color: #595c66;
  text-align: left;
  line-height: 20px;
  font-weight: normal;
  white-space: pre-line;
  p {
    word-break: break-word;
    margin: 0;
    padding: 0;
    white-space: pre-wrap;

    i {
      word-break: break-all;
    }
  }
}
@include notifications(description-ellipsis) {
  position: relative;
  height: 40px;
  overflow: hidden;
  word-break: break-word;
}
@include notifications(description-point) {
  cursor: pointer;
  position: absolute;
  bottom: 0;
  right: 0;
  padding-left: 20px;
  background-image: linear-gradient(270deg, #ffffff 72%, rgba(255, 255, 255, 0) 100%);
  font-size: 12px;
  color: #f76a31;
  font-weight: 400;
}
@include notifications(close) {
  display: inline-block;
  height: 24px;
  width: 24px;
  border-radius: 12px;
  text-align: center;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  color: #fff;
  opacity: 0.7;
  background: #282b33;
  padding-top: 2px;
  box-sizing: border-box;
  &:hover {
    opacity: 1;
  }
  i {
    font-weight: bold;
    font-size: 18px;
  }
}

//@include notifications(image) {
//  display: inline-block;
//  margin-top: 8px;
//  height: 156px;
//  width: 312px;
//  border-radius: 3px;
//  overflow: hidden;
//  img {
//    width: 312px;
//  }
//}
::v-deep .pb-skeleton {
  height: 100%;
}
</style>
